export type KVUnitType = 'Meters' | 'Feet' | 'Inches' | 'Millimeters'

export function normalizeKVUnit(u: unknown): KVUnitType | undefined {
  if (!u) return undefined
  const s = String(u).trim().toLowerCase()
  switch (s) {
    case 'm':
    case 'meter':
    case 'meters':
      return 'Meters'
    case 'ft':
    case 'foot':
    case 'feet':
      return 'Feet'
    case 'in':
    case 'inch':
    case 'inches':
      return 'Inches'
    case 'mm':
    case 'millimeter':
    case 'millimeters':
      return 'Millimeters'
    default:
      return undefined
  }
}
